module.exports = __webpack_public_path__ + "media/bootstrap-icons/slash-circle-d33a650e.svg";